import { connect } from 'react-redux';
import { expandAndFocusCommentPanel } from '../../../DeviationPage/redux/actions';
import { getVisiblePanel } from '../../../DeviationPage/redux/selectors';
const mapStateToProps = (state, { actionBarType, deviation })=>({
        isCommentPanelOpen: getVisiblePanel(state, actionBarType) === 'comment'
    });
const mapDispatchToProps = {
    onToggleCommentPanel: expandAndFocusCommentPanel
};
export default connect(mapStateToProps, mapDispatchToProps);

//# sourceMappingURL=CommentButton.container.js.map